import * as React from 'react'
import { useMemo } from 'react'
import { EditableCustomField } from '@user/components/CustomFields'
import type { CustomField } from '@sales-center/common'
import type { ICustomFieldFormSetting } from '@user/store/entityFormSettings'
import Grid from '@mui/material/Grid'
import { TextFieldProps } from '@mui/material/TextField'
import { useHideOptional } from '@user/components/CustomFields/Editable/useHideOptional'

type Props = {
  field: CustomField
  hideOptional?: boolean
  avoidValidateOnBlur?: boolean
  customSettings: ICustomFieldFormSetting[]
  textFieldProps?: TextFieldProps
  margin?: 'none' | 'dense' | 'normal'
}

export function CustomFieldListItem(props: Props) {
  const {
    field,
    hideOptional,
    customSettings,
    textFieldProps,
    margin,
    avoidValidateOnBlur,
  } = props

  const fieldSetting = useMemo(
    () => customSettings.find((x) => x.customFieldId === field.id),
    [customSettings, field.id],
  )

  const showField = useHideOptional({ hideOptional, fieldSetting })

  return fieldSetting?.enabled && showField ? (
    <Grid item xs={12}>
      <EditableCustomField
        field={field}
        margin={margin ?? 'normal'}
        fieldSetting={fieldSetting}
        hideOptional={hideOptional}
        textFieldProps={textFieldProps}
        avoidValidateOnBlur={avoidValidateOnBlur}
      />
    </Grid>
  ) : null
}
